import { TFailureListingOffers, TRequestListingOffers, TSuccessListingOffers } from './loadListingOffers';
import { ITypedReduxAction } from '../../types/redux';

export enum EListingOffersActionType {
  RemoveOffers = 'listingOffers/removeOffers',
  SetPage = 'listingOffers/setPage',
  MarkEmpty = 'listingOffers/markEmpty',
}

export type TListingRemoveOffers = ITypedReduxAction<EListingOffersActionType.RemoveOffers>;
export type TListingSetPage = ITypedReduxAction<EListingOffersActionType.SetPage, number>;
export type TListingMarkEmpty = ITypedReduxAction<EListingOffersActionType.MarkEmpty>;

export type TListingOffersActions =
  | TListingRemoveOffers
  | TListingSetPage
  | TListingMarkEmpty
  | TRequestListingOffers
  | TSuccessListingOffers
  | TFailureListingOffers;
